<template>
<select v-model.number="selectedDevice" class="microphone-dropdown" :disabled="disabled" @change="$emit('change', $event.target.value)">
    <option v-for="(device, index) in audioDevices" :key="device.deviceId" :value="index">
        {{ getLabel(device.label) || 'Microphone ' + (audioDevices.indexOf(device) + 1) }}
    </option>
</select>
</template>

<script>
export default {
    name: 'AudioInputDropdown',
    props: {
        value: Number,
        placeholder: {
            type: String,
            default: 'Select a microphone'
        },
        disabled: Boolean
    },
    data() {
        return {
            audioDevices: []
        }
    },
    computed: {
        selectedDevice: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    async created() {
        await this.getAudioDevices();
    },
    methods: {
        async getAudioDevices() {
            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                this.audioDevices = devices.filter(device => device.kind === 'audioinput');

                if (!this.value && this.audioDevices.length > 0) {
                    this.$emit('input', this.audioDevices[0].deviceId);
                }

            } catch (error) {
                console.error('Error getting audio devices:', error);
            }
        },
        getLabel(str) {
            const match = str.match(/\(([^)]+)\)/);
            const text = match ? match[1] : str;

            if (text.length <= 50) return text;

            const trimmed = text.slice(0, 50);
            const lastSpace = trimmed.lastIndexOf(' ');
            return lastSpace > -1 ? trimmed.slice(0, lastSpace) : trimmed;
        }

    }
};
</script>
